module.exports = __webpack_public_path__ + "static/media/f900.b3bafe4d.jpg";